import classNames from 'classnames';
import React, { useCallback } from 'react';

import { ZonedDate } from '@eika-infrastruktur/date';
import { DateInput } from '@eika/date-input';

import DateRangeInputsProps from './date-range-types';

import './date-range-input.scss';

const DateRangeInputs: React.FC<DateRangeInputsProps> = ({
    mainLabel,
    fromDate,
    toDate,
    maxDate,
    minDate,
    className,
    ignoreDateCompare = false,
    contentWrapperClassName,
    ...rest
}) => {
    const defineActualDates = useCallback(
        (date: ZonedDate | undefined, isFromDate = false) => {
            const setMethod = isFromDate ? fromDate.onChange : toDate.onChange;

            if (ignoreDateCompare) {
                setMethod(date);
                return;
            }

            const currentFromDateTime = fromDate.date?.getTime();
            const currentToDateTime = toDate.date?.getTime();
            const dateTime = date?.getTime();

            if (isFromDate && currentToDateTime && dateTime && dateTime > currentToDateTime) {
                toDate.onChange(date);
            }

            if (!isFromDate && currentFromDateTime && dateTime && dateTime < currentFromDateTime) {
                fromDate.onChange(date);
            }

            setMethod(date);
        },
        [fromDate, toDate, ignoreDateCompare],
    );

    return (
        // eslint-disable-next-line
        <section className={classNames('sgw-date-range-input__wrapper', className)} {...rest}>
            <fieldset className="sgw-date-range-input__fieldset">
                <legend className="sgw-select__mainlabel">{mainLabel}</legend>
                <div className={classNames('sgw-date-range-input__content-wrapper', contentWrapperClassName)}>
                    <DateInput
                        maxDate={maxDate}
                        minDate={minDate}
                        // eslint-disable-next-line
                        {...fromDate}
                        onChange={(date) => defineActualDates(date, true)}
                    />

                    <DateInput
                        maxDate={maxDate}
                        minDate={minDate}
                        // eslint-disable-next-line
                        {...toDate}
                        onChange={(date) => defineActualDates(date)}
                    />
                </div>
            </fieldset>
        </section>
    );
};

export default DateRangeInputs;
